/* LAYOUT */
export const CHANGE_LAYOUT = "CHANGE_LAYOUT";
export const CHANGE_LAYOUT_WIDTH = "CHANGE_LAYOUT_WIDTH";
export const CHANGE_SIDEBAR_THEME = "CHANGE_SIDEBAR_THEME";
export const CHANGE_SIDEBAR_TYPE = "CHANGE_SIDEBAR_TYPE";

// topbar
export const CHANGE_TOPBAR_THEME = "CHANGE_TOPBAR_THEME";

/* RIGHT SIDEBAR */
export const TOGGLE_RIGHT_SIDEBAR = "TOGGLE_RIGHT_SIDEBAR";
export const SHOW_RIGHT_SIDEBAR = "SHOW_RIGHT_SIDEBAR";
export const HIDE_RIGHT_SIDEBAR = "HIDE_RIGHT_SIDEBAR";

// Preloader
export const CHANGE_PRELOADER = "CHANGE_PRELOADER";
export const types = {
  EDIT_DEALER_BYID: "EDIT_DEALER_BYID",
  EDIT_DEALER_BYID_SUCCESS: "EDIT_DEALER_BYID_SUCCESS",
  FETCH_DEALER_BYID: "FETCH_DEALER_BYID",
  FETCH_DEALER_BYID_SUCCESS: "FETCH_DEALER_BYID_SUCCESS",
  FETCH_DEALERS: "FETCH_DEALERS",
  FETCH_FILTER_DEALERS: "FETCH_FILTER_DEALERS",
  FETCH_DEALERS_SUCCESS: "FETCH_DEALERS_SUCCESS",
  FETCH_DEALERS_FILTER_SUCCESS: "FETCH_DEALERS_FILTER_SUCCESS",
  UPLOAD_DEALERS: "UPLOAD_DEALERS",
  UPLOAD_DEALERS_SUCCESS: "UPLOAD_DEALERS_SUCCESS",
  FETCH_AVAIL_DEALERS: "FETCH_AVAIL_DEALERS",
  FETCH_AVAIL_DEALERS_SUCCESS: "FETCH_AVAIL_DEALERS_SUCCESS",
  CREATE_DEALER: "CREATE_DEALER",
  CREATE_DEALER_SUCCESS: "CREATE_DEALER_SUCCESS",

  DELETE_DEALER: "DELETE_DEALER",
  DELETE_DEALER_SUCCESS: "DELETE_DEALER_SUCCESS",
};
